import React from "react";

const Dashboard = React.lazy(() => import("src/pages/dashboard/Dashboard"));

const routes = [{ path: "/dashboard/landing", name: "Dashboard", element: Dashboard }];

export default routes;
